class Accordion extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('[data-title]').forEach((faq) => {
      faq.addEventListener('click', (e) => {
        this.toggleContent(e);
      });

      // Add keyboard support for Enter and Space keys
      faq.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleContent(e);
        }
      });
    });
    window.addEventListener('resize', () => {
      if (this.querySelectorAll('[data-open]')?.length == 1) {
        this.querySelector(
          '[data-open] [data-content]'
        ).style.maxHeight = `${this.getFolderHeight(
          this.querySelector('[data-open="true"]'),
          this.querySelector('[data-open="true"] [data-content]')
        )}px`;
      }
    });

    if (this.classList.contains('accordion--product-form')) {
      setTimeout(() => {
        this.toggleContent();
      }, 0);
    }
  }
  toggleContent(e) {
    const folder = e
      ? e.target.closest('.accordion__folder')
      : this.querySelector('.accordion__folder');
    const folderContent = folder.querySelector('[data-content]');
    if (folder.getAttribute('data-open')) {
      this.hideFolder(folder, folderContent);
    } else {
      if (
        this.querySelectorAll('[data-open]')?.length == 1 &&
        !this.classList.contains('accordion--product-form')
      ) {
        this.hideFolder(
          this.querySelector('[data-open="true"]'),
          this.querySelector('[data-open="true"] [data-content]')
        );
      }
      folder.setAttribute('data-open', true);
      folder
        .querySelector('[data-title]')
        ?.setAttribute('aria-expanded', 'true');
      const rows = folderContent.getAttribute('data-row-size');
      if (rows) {
        folderContent.style.maxHeight = `${227 + 66 * rows}px`;
      } else {
        folderContent.style.maxHeight = `${this.getFolderHeight(
          folder,
          folderContent
        )}px`;
      }
    }
  }
  hideFolder(folder, folderContent) {
    folderContent.style.maxHeight = 0;
    folder.removeAttribute('data-open');
    folder
      .querySelector('[data-title]')
      ?.setAttribute('aria-expanded', 'false');
  }
  getFolderHeight(folder, folderContent) {
    //Approximates max height of FAQ answer content. Used for open/closing transitions

    return (
      parseInt(
        ((folder
          .querySelector('[data-char-count]')
          .getAttribute('data-char-count') *
          16) /
          (folderContent.offsetWidth || folderContent.clientWidth) /
          2) *
          22
      ) +
      80 * (folder.querySelectorAll('p').length + 1)
    );
  }
}

customElements.define('accordion-module', Accordion);
